import React, { useState } from 'react';
import { t } from '../../locales/translate';
import { sortBy } from 'lodash';
import { FormSelect } from '../Form/Select/FormSelect';
import { Section } from '../../model/seatmap/types';

interface Props {
  onChange: (section: Section) => void;
  sections: Section[];
}

export function QuickNav({ onChange, sections }: Props): JSX.Element | null {
  const [id, setId] = useState<string | null>(null);
  const options = sortBy(
    sections.map((e) => ({ value: e.id, label: e.name })),
    'label'
  );
  if (!options.length) return <></>;
  const current = sections.find((e) => e.id === id) || sections[0];

  return (
    <FormSelect
      required
      options={options}
      label={t.model.venueLayout.section}
      value={current?.id}
      onChange={(id) => {
        const section = sections.find((e) => e.id === id);
        if (section) {
          setId(section.id);
          onChange(section);
        } else {
          setId(null);
        }
      }}
    />
  );
}
